<script>
  import { cart } from "$lib/state/cart";
  import { afterUpdate } from "svelte";
  import { bodyScroll } from "$lib/utils/PreventBodyScroll";
  import Bag from "./Bag.svelte";

  /** @typedef {import ('magento-gql-types').Cart} Cart */

  /**@type {boolean}*/
  let isOpenModal = false;
  /** @type {?Cart} */
  let shoppingBag;
  cart.subscribe((item) => (shoppingBag = item));

  let xWidth = 0;

  afterUpdate(() => {
    if (isOpenModal) {
      bodyScroll.prevent();
    } else {
      bodyScroll.allow();
    }
  });
</script>

<svelte:window
  on:keydown={(e) => {
    if (e.code === "Escape") {
      isOpenModal = false;
    }
  }}
  bind:innerWidth={xWidth}
/>

<div class="wrapper">
  {#if xWidth >= 768}
    <button class="shopping-bag-icon" on:click={() => (isOpenModal = !isOpenModal)}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.492 25.525">
        <g id="Grupo_286" data-name="Grupo 286" transform="translate(0 -0.119)">
          <path
            id="Unión_2"
            data-name="Unión 2"
            d="M3,24a3,3,0,0,1-3-3V6.927a3,3,0,0,1,3-3H4.364a4.7,4.7,0,0,1,9.273,0H15a3,3,0,0,1,3,3V21a3,3,0,0,1-3,3Z"
            transform="translate(0.213 1)"
            fill="var(--global)"
          />
          <path
            id="Union_2_-_Outline"
            data-name="Union 2 - Outline"
            d="M16.243,24.133A1.859,1.859,0,0,0,18.1,22.276V7.426a1.859,1.859,0,0,0-1.856-1.856H14.767A1.392,1.392,0,0,1,13.4,4.428a3.714,3.714,0,0,0-7.3,0A1.392,1.392,0,0,1,4.725,5.569H3.249A1.859,1.859,0,0,0,1.392,7.426V22.276a1.859,1.859,0,0,0,1.856,1.856H16.243m0,1.392H3.249A3.249,3.249,0,0,1,0,22.276V7.426A3.249,3.249,0,0,1,3.249,4.177H4.725a5.106,5.106,0,0,1,10.042,0h1.476a3.249,3.249,0,0,1,3.249,3.249V22.276A3.249,3.249,0,0,1,16.243,25.525Z"
            transform="translate(0 0.119)"
            fill="var(--global)"
          />
        </g>
      </svg>
      {#if shoppingBag && shoppingBag.itemsV2 && shoppingBag.itemsV2?.total_count > 0}
        <span class="items">{shoppingBag?.itemsV2?.total_count}</span>
      {/if}
    </button>
  {:else}
    <a href="/cart" class="shopping-bag-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.492 25.525">
        <g id="Grupo_286" data-name="Grupo 286" transform="translate(0 -0.119)">
          <path
            id="Unión_2"
            data-name="Unión 2"
            d="M3,24a3,3,0,0,1-3-3V6.927a3,3,0,0,1,3-3H4.364a4.7,4.7,0,0,1,9.273,0H15a3,3,0,0,1,3,3V21a3,3,0,0,1-3,3Z"
            transform="translate(0.213 1)"
            fill="var(--global)"
          />
          <path
            id="Union_2_-_Outline"
            data-name="Union 2 - Outline"
            d="M16.243,24.133A1.859,1.859,0,0,0,18.1,22.276V7.426a1.859,1.859,0,0,0-1.856-1.856H14.767A1.392,1.392,0,0,1,13.4,4.428a3.714,3.714,0,0,0-7.3,0A1.392,1.392,0,0,1,4.725,5.569H3.249A1.859,1.859,0,0,0,1.392,7.426V22.276a1.859,1.859,0,0,0,1.856,1.856H16.243m0,1.392H3.249A3.249,3.249,0,0,1,0,22.276V7.426A3.249,3.249,0,0,1,3.249,4.177H4.725a5.106,5.106,0,0,1,10.042,0h1.476a3.249,3.249,0,0,1,3.249,3.249V22.276A3.249,3.249,0,0,1,16.243,25.525Z"
            transform="translate(0 0.119)"
            fill="var(--global)"
          />
        </g>
      </svg>
      {#if shoppingBag && shoppingBag.itemsV2 && shoppingBag.itemsV2?.total_count > 0}
        <span class="items">{shoppingBag?.itemsV2.total_count}</span>
      {/if}
    </a>
  {/if}
  {#if isOpenModal}
    <Bag {shoppingBag} bind:isOpenModal />
  {/if}
</div>

<style>
  .wrapper {
    position: relative;
  }
  .shopping-bag-icon {
    width: 1.9rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: 0;
    position: relative;
    cursor: pointer;
  }
  .shopping-bag-icon svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
  .items {
    position: absolute;
    top: 58%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--white);
  }
</style>
